import * as React from 'react';
import { Box } from '@mui/material';

import { ReactComponent as CoraLogoSvg } from 'assets/images/logo_cora.svg';
import { ReactComponent as CoraLogoMiniSvg } from 'assets/images/logo_cora_mini.svg';

interface AppLogoProps {
  mini?: boolean;
}

export const AppLogo: React.FC<AppLogoProps> = (props) => {
  const { mini = false } = props;

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="fit-content"
      onClick={() => window.open('https://www.cleancode.us/')}
      sx={{
        cursor: 'pointer',
      }}
    >
      {mini ? <CoraLogoMiniSvg /> : <CoraLogoSvg />}
    </Box>
  );
};
